exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.actions[data-v-7194a311] {\n  right: 0;\n  top: 110%;\n  z-index: 5;\n  width: 180px;\n}\n.actions li[data-v-7194a311] {\n    cursor: pointer;\n    padding: 15px 0;\n    border-bottom: #c5d0de solid 1px;\n    margin: 0 15px;\n}\n.actions li[data-v-7194a311]:last-child {\n      border-bottom: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7194a311","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/threeDots.vue
// module id = 1277
// module chunks = 0